import { usePlayerSubscription } from "@/views/PlayerSubscriptionEditorView/composables/playerSubscription";

export function useLiveStream({ id } = {}) {
  const {
    loadPlayerSubscription,
    reloadPlayerSubscription,
    prepareDataForSubmission,
    prepareFiltersForSubmission,
    getHumanReadableInfo,
    data,
    sideState,
    isLoading,
    isDataInitialized,
    hasUnsavedChanges,
    unsetHasUnsavedChanges,
    initializeHasUnsavedChangesWatcher,
  } = usePlayerSubscription({ id, sideFeatureImplementationKey: 'liveStream' });

  const streamTypeOptions = [
    {
      name: "rtmp",
      label: "RTMP"
    },
    {
      name: "youtube",
      label: "Youtube"
    },
    {
      name: "webpage",
      label: "Web Page"
    }
  ]

  const bindingOptionsInitialValues = {
    streamType: streamTypeOptions[0].name,
    streamUrl: "",
    startDate: new Date().toISOString().split('T')[0],
    startTime: new Date().toTimeString().slice(0, 8),
    // Default end date is today
    endDate: new Date().toISOString().split('T')[0],
    // Default end time is 1 hour from now
    endTime: new Date(Date.now() + 60 * 60 * 1000).toTimeString().slice(0, 8),
    isStartStream: false
  }

  function getStreamDuration(
    startDate: string,
    startTime: string,
    endDate: string,
    endTime: string
  ) {
    if(endDate && endTime) {
      const endDateTimestamp = new Date(endDate + 'T' + endTime).getTime();
      const startDateTimestamp = new Date(startDate + 'T' + startTime).getTime();

      const durationInMinutes = Math.round((endDateTimestamp - startDateTimestamp) / (1000 * 60));
      
      if (durationInMinutes < 0) {
        return 'Stream End Time is before Start Time!';
      }

      if (durationInMinutes < 60) {
        return `${durationInMinutes} minutes`;
      }
      
      const hours = Math.floor(durationInMinutes / 60);
      const minutes = durationInMinutes % 60;
      
      if (minutes === 0) {
        return `${hours} hour${hours > 1 ? 's' : ''}`;
      }
      
      return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minute${minutes > 1 ? 's' : ''}`;
    }
    return '0 minutes';
  }
  
  return {
    loadPlayerSubscription,
    reloadPlayerSubscription,
    prepareDataForSubmission,
    prepareFiltersForSubmission,
    getHumanReadableInfo,
    data,
    sideState,
    isLoading,
    isDataInitialized,
    hasUnsavedChanges,
    unsetHasUnsavedChanges,
    initializeHasUnsavedChangesWatcher,
    bindingOptionsInitialValues,
    streamTypeOptions,
    getStreamDuration
  }
}